import styled from "styled-components";
import gloria from "assets/images/NH21_722_ELLE_GLORIA2154.jpg";

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  position: relative;
  padding: 80px 0;
`;

export const GloriaComposition = styled.img.attrs({ src: gloria })`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;
